import { render } from "./Salaries.vue?vue&type=template&id=5d6d784a&scoped=true"
import script from "./Salaries.vue?vue&type=script&lang=js"
export * from "./Salaries.vue?vue&type=script&lang=js"

import "./Salaries.vue?vue&type=style&index=0&id=5d6d784a&lang=scss&scoped=true"

import exportComponent from "/builds/springup/oa-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d6d784a"]])

export default __exports__